module.exports = __webpack_public_path__ + "img/Frente-24-02 open.948de922.jpg";